import {
  ArrowDown,
  BillingIcon,
  Clients,
  Dashboard,
  Information,
  Invoice,
  LogoEn,
  Meeting,
  ProductsIcon,
  Projects,
  QuotationsIconWithoutBg,
  Requests,
  Settings,
  Tasks,
  Teams,
  Users,
} from "../../components/styled/AllImages";
import UserPermissions from "../../pages/admin/users/components/UserPermissions";
import UserPersonalInfo from "../../pages/admin/users/components/UserPersonalInfo";

export const SidebarList = [
  // {
  //   title: "dashboard",
  //   icon: Dashboard,
  //   url: "dashboard",
  //   id: 1,
  // },
  // {
  //   title: "projects",
  //   icon: Projects,
  //   id: 2,
  //   url: "projects",
  // },
  // {
  //   title: "tasks",
  //   icon: Tasks,
  //   url: "tasks",
  //   id: 3,
  // },
  // {
  //   title: "teams",
  //   icon: Teams,
  //   url: "teams",
  //   id: 4,
  // },
  {
    title: "products",
    icon: ProductsIcon,
    url: "products-categories",
    id: 1,
  },
  // {
  //   title: "meetings",
  //   icon: Meeting,
  //   url: "meetings",
  //   id: 6,
  // },
  // {
  //   title: "information",
  //   icon: Information,
  //   url: "information",
  //   id: 7,
  // },
  {
    title: "clients",
    icon: Clients,
    url: "clients",
    id: 9,
  },
  {
    title: "quotations",
    icon: QuotationsIconWithoutBg,
    url: "quotations",
    id: 10,
  },
  {
    title: "sales_invoices",
    icon: Invoice,
    url: "sales-invoices",
    id: 11,
},
  {
    title: "users",
    icon: Users,
    id: 5,
    url: "users",
  },
  // {
  //   title: "requests",
  //   icon: Requests,
  //   url: "requests",
  //   id: 12,
  // },
  // {
  //   title: "billing",
  //   icon: BillingIcon,
  //   url: "billing",
  //   id: 13,
  // },
  {
    title: "settings",
    icon: Settings,
    id: 14,
    url: "settings/establishment",
    // submenu: [
    //   {
    //     title: "establishment",
    //     url: "settings/establishment",
    //   },
    // ],
  },
];


export const userFormTabs = [
  {
    id: 1,
    title: "personal_information",
    component: UserPersonalInfo,
    fields: [
      "name",
      "email",
      "phone",
      "password",
      "job_title",
      "additional_info",
      "id_number",
    ],
  },
  {
    id: 2,
    title: "rights_permissions",
    component: UserPermissions,
  },
];